import Loadable from 'react-loadable'

export default Loadable({
  loader: () => import(/* webpackChunkName: "wholesale" */ './index'),
  loading: () => null,
})
